import { render } from "./MigracionTipoServicio.vue?vue&type=template&id=537b84c7"
import script from "./MigracionTipoServicio.vue?vue&type=script&lang=js"
export * from "./MigracionTipoServicio.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__